// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"Gold__baseFont__2l3in","gold":"Gold__gold__1Ujkm","baseColor":"Gold__baseColor__4Ih5g","baseFontFamily":"Gold__baseFontFamily__143jU","isFlat":"Gold__isFlat__3mqCr"};